export const getEnabledSkills = (skills = []) => {
  try {
    const validSkills = {
      jira: 1,
      standups: 1,
      wiki: 1,
    };

    const options = [];
    // console.log(skills);
    skills.forEach((skill) => {
      if (skill.is_enabled && validSkills[skill.key]) {
        if (skill.key === 'jira') {
          if (
            skill.skill_metadata &&
            skill.skill_metadata.sub_skills &&
            skill.skill_metadata.sub_skills.length > 0
          ) {
            skill.skill_metadata.sub_skills.forEach((subSkill) => {
              if (subSkill.disabled === false) {
                if (subSkill.key === 'jira_software') {
                  options.push({ name: 'Issues', value: 'issues' });
                } else if (subSkill.key === 'jira_service_desk') {
                  options.push({ name: 'Requests', value: 'requests' });
                  options.push({ name: 'Approvals', value: 'approvals' });
                } else if (subSkill.key === 'jira_reports') {
                  options.push({ name: 'Reports', value: 'reports' });
                }
              }
            });
          }
        } else if (
          skill.key === 'wiki' &&
          skill.skill_metadata &&
          skill.skill_metadata.disabled === false
        ) {
          options.push({ name: 'Wiki', value: 'wiki' });
        } else if (
          skill.key === 'standups' &&
          skill.skill_metadata &&
          skill.skill_metadata.disabled === false
        ) {
          options.push({ name: 'Check-ins', value: 'checkins' });
        }
      }
    });

    return options;
  } catch (error) {
    // console.log(error, 'aaaa');
    return [];
  }
};

export const defaultButtonsForIssues = () => {
  return [
    { name: '+ Issue', value: 'issue' },
    { name: 'Find', value: 'find' },
    { name: 'Channel Sync', value: 'channelsync' },
  ];
};

export const defaultButtonsForRequests = () => {
  return [
    { name: '+ Request', value: 'issue' },
    { name: 'Find', value: 'find' },
    { name: 'Channel Sync', value: 'channelsync' },
  ];
};

export const defaultButtonsForApprovals = () => {
  return [
    { name: '+ Request', value: 'issue' },
    { name: 'Find', value: 'find' },
    { name: 'Channel Sync', value: 'channelsync' },
  ];
};

export const defaultButtonsForCheckins = () => {
  return [
    { name: '+ Request', value: 'issue' },
    { name: 'Find', value: 'find' },
    { name: 'Channel Sync', value: 'channelsync' },
  ];
};

export const defaultButtonsForReports = () => {
  return [
    { name: '+ Request', value: 'issue' },
    { name: 'Find', value: 'find' },
    { name: 'Channel Sync', value: 'channelsync' },
  ];
};

export const defaultButtonsForWiki = () => {
  return [
    { name: '+ find', value: 'find' },
    { name: 'Add to COnfluence', value: 'add_to_confluence' },
    { name: 'Update Confluence', value: 'channelsync' },
  ];
};

export const defaultButtonsListItems = (pageViewType = 'issue') => {
  const product = pageViewType === 'issues' ? 'issue' : 'ticket';
  return [
    {
      name: `+ ${pageViewType === 'issue' ? 'Issue' : 'Request'}`,
      purpose: `Create a new ${product}`,
      creator: 'Troopr',
      isDeault: true,
    },
    {
      name: 'Find',
      purpose: `Search for ${product}s matching key phrase`,
      creator: 'Troopr',
      isDeault: true,
    },
    {
      name: 'Channel sync',
      purpose: `Create new channel sync to discuss a ${product}`,
      creator: 'Troopr',
      isDeault: true,
    },
  ];
};
